import styled, { css } from 'styled-components';


import Tooltip from '../Tooltip'

interface ContainerProps {
  isFocused: boolean
  isFilled: boolean
  isErrored: boolean
  sizeBox?: 'small' | 'large'
}

export const Container = styled.div<ContainerProps>`
  background: #FFF;
  border-radius: 4px;
  box-shadow: 0px 2px 4px rgba(61, 69, 67, 0.05);
  padding: 16px 12px;
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: 600;

  position: relative;

  border: 2px solid #f4f6f5;
  color: ${props => props.theme.colors.grey02};

  margin-bottom: 8px;
  transition: 0.2s;

  &:hover {
    border: 2px solid ${props => props.theme.colors.mainColor};
  }

  > div {
    flex: 1;
    > div {
      svg {
        color: ${props => props.theme.colors.mainColor};
      }
      span {
        background-color: transparent;
      }
    }
  }


  ${({ sizeBox }) => (sizeBox && sizeBox === 'large') && css`
    height: 70px;
    > label {
      font-size: 14px;
    }`}


  ${props =>
    props.isErrored &&
    css`
      border-color: ${props => props.theme.colors.dange};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${props => props.theme.colors.mainColor};
      color: ${props => props.theme.colors.mainColor};
    `}


  ${props =>
    props.isFilled &&
    css`
      color: 'black';
    `}

  > label {
    position: absolute;
    top: 16px;
    left: 12px;
    padding-right:12px;

    color: 'black' ;

    transition: .2s;
    pointer-events: none;
  }
  /* ${props =>
    props.isErrored && (props.sizeBox && props.sizeBox === 'large') &&
    css`
      > label {
        font-size:13px;
        padding-right:10px;
      }
    `} */

${
  props => (props.isFilled || props.isFocused) && css`
    padding-top:24px;
    ${props.sizeBox === 'large' && css`
      padding-top:33px;
    `}
    > label {
      transform: translateY(-12px);
      font-size: 12px;
      letter-spacing: 0.1em;
    }
  `}



span {
  color: 'black';
  margin-right: 4px;
  display: inline-block;
}

input {
  appearance: none;
  color: 'black';
  flex: 1;
  border: 0;
  background: transparent;

    &::placeholder {
    color: 'black';
  }
}
`

export const Error = styled(Tooltip)`
  height: 20px;

  svg {
    position: absolute;
    right: 0;
  }

  span {
    background: ${ props => props.theme.colors.dange};
    color: #fff;

      &::before {
      border-color: ${ props => props.theme.colors.dange} transparent;
    }
  }
`
